import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import {
  EMPTY_COACH_EINVOICE_PROFILE,
  type CoachEInvoiceProfile,
} from '../types/coachEInvoiceProfile';

const COLLECTION = 'coach_invoice_profiles';

const mergeProfile = (raw?: Partial<CoachEInvoiceProfile> | null): CoachEInvoiceProfile => ({
  ...EMPTY_COACH_EINVOICE_PROFILE,
  ...(raw || {}),
  country: String(raw?.country || 'DE').trim().toUpperCase() || 'DE',
  reverseCharge: raw?.reverseCharge === true,
  defaultPaymentTermsDays:
    typeof raw?.defaultPaymentTermsDays === 'number' && raw.defaultPaymentTermsDays > 0
      ? raw.defaultPaymentTermsDays
      : 14,
});

/** Persönliches E-Rechnungsprofil — nicht aus Team/Global-Daten. */
export async function loadCoachEInvoiceProfile(coachId: string): Promise<CoachEInvoiceProfile> {
  if (!coachId) return { ...EMPTY_COACH_EINVOICE_PROFILE };
  try {
    const snap = await getDoc(doc(db, COLLECTION, coachId));
    if (snap.exists()) {
      return mergeProfile(snap.data() as Partial<CoachEInvoiceProfile>);
    }
  } catch {
    // empty
  }
  return { ...EMPTY_COACH_EINVOICE_PROFILE };
}

export async function saveCoachEInvoiceProfile(
  coachId: string,
  profile: CoachEInvoiceProfile
): Promise<{ savedRemote: boolean }> {
  if (!coachId) return { savedRemote: false };
  try {
    await setDoc(
      doc(db, COLLECTION, coachId),
      {
        ...profile,
        updatedAt: new Date().toISOString(),
      },
      { merge: true }
    );
    return { savedRemote: true };
  } catch {
    return { savedRemote: false };
  }
}
